import { render, staticRenderFns } from "./AutoInfracaoGoPonto.vue?vue&type=template&id=0cf52d0c&lang=pug"
import script from "./AutoInfracaoGoPonto.vue?vue&type=script&lang=js"
export * from "./AutoInfracaoGoPonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports